import React, { useEffect, useRef, useState } from "react";

const animationStyles = {
  "fade-up": { hidden: "opacity-0 translate-y-12", visible: "opacity-100 translate-y-0" },
  "fade-down": { hidden: "opacity-0 -translate-y-12", visible: "opacity-100 translate-y-0" },
  "fade-left": { hidden: "opacity-0 translate-x-12", visible: "opacity-100 translate-x-0" },
  "fade-right": { hidden: "opacity-0 -translate-x-12", visible: "opacity-100 translate-x-0" },
  scale: { hidden: "opacity-0 scale-95", visible: "opacity-100 scale-100" },
  fade: { hidden: "opacity-0", visible: "opacity-100" },
};

export function ScrollAnimation({
  children,
  className = "",
  delay = 0,
  animation = "fade-up",
  duration = 800,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), delay);
        }
      },
      { threshold: 0.08 }
    );
    const current = ref.current;
    if (current) observer.observe(current);
    return () => {
      if (current) observer.unobserve(current);
    };
  }, [delay]);

  const styles = animationStyles[animation];

  return (
    <div
      ref={ref}
      className={`transition-all ease-out ${isVisible ? styles.visible : styles.hidden} ${className}`}
      style={{ transitionDuration: `${duration}ms` }}
    >
      {children}
    </div>
  );
}
